import { AfterViewInit, Component, inject, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { IconsService } from 'src/app/shared/services/icons.service';
import { ImageService } from 'src/app/shared/services/image.service';
import { ModalInvoiceComplementComponent } from 'src/app/components/modals/modal-invoice-complement.component';
import { ModalInvoiceNotaComponent } from 'src/app/components/modals/modal-invoice-nota.component';
import { ModalInvoiceCancelComponent } from 'src/app/components/modals/modal-invoice-cancel.component';
import { ModalOptionsPayComponent } from 'src/app/components/modals/modal-options-pay.component';
import * as xml2js from 'xml2js';
import { AuthService } from 'src/app/shared/services/auth.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { hasCreditNoteXml, inventoryCreditNoteAmount, inventoryCreditNoteStamp, isInventoryCreditNote } from 'src/app/shared/utils/inventory-credit-note.utils';

@Component({
  selector: 'app-invoice-show',
  template: `
    <div class="d-flex mb-4 mt-4">
      <div class="flex-fill">
        <h1>Facturación</h1>
        <xng-breadcrumb></xng-breadcrumb>
      </div>
    </div>
    <div class="flex-fill">
      <div class="d-flex">
        <div class="me-3" style="width: 222px !important; min-width: 222px !important;">
          <ul #sidebar app-nav-invoices [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
        </div>
        <div #pages class="flex-fill">
          <div class="d-flex">
            <div>
            </div>
            <div class="flex-fill" style="min-width: 440px !important; width: 440px !important;">
              <div class="flex-fill list-group">
                <div class="list-group-item py-3" *ngIf="invoice?.tipo==0||invoice?.tipo==5">
                  <div class="d-flex">
                    <div>                    
                      <div class="d-flex">
                        <div class="flex-fill">
                          <h5>Emisor</h5>
                          <table class="table table-sm my-2 border-0" style="font-size: 0.8em;">
                            <tbody>
                              <tr>
                                <th>RFC</th>
                                <td class="text-end">{{emisor.Rfc}}</td>
                              </tr>
                              <tr>
                                <th>Nombre</th>
                                <td class="text-end">{{emisor.Nombre}}</td>
                              </tr>
                              <tr>
                                <th>Regimen Fiscal</th>
                                <td class="text-end">{{emisor.RegimenFiscal}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="ms-auto text-end mt-2">
                        <button *ngIf="invoice?.tipo == 5" (click)="regenerateGenericInvoice()" class="btn btn-sm btn-outline-secondary">
                          <fa-icon [icon]="icons.faDownload" class="me-2"></fa-icon>
                          Descargar factura
                        </button>                      
                        <button (click)="regenerateInvoice()" *ngIf="invoice?.tipo == 0" class="btn btn-sm btn-outline-secondary">
                          <fa-icon [icon]="icons.faDownload" class="me-2"></fa-icon>
                          Descargar factura
                        </button>
                      <div *ngIf="!invoice?.pdf">
                      </div>
                      <button type="button" 
                        class="btn btn-sm btn-outline-secondary mt-2"
                        *ngIf="invoice?.canceled" 
                        (click)="downloadAcuse(invoice)"
                      >
                        <fa-icon [icon]="icons.faDownload" *ngIf="!downloading_acuse"></fa-icon>
                        <fa-icon [icon]="icons.faCircleNotch" animation="spin" *ngIf="downloading_acuse"></fa-icon>
                        Descargar acuse
                      </button>
                      <div *ngIf="authService.hasPermission('can_read_invoices')">
                        <button 
                          class="btn btn-sm btn-outline-danger mt-3" 
                          (click)="openModalDelete(invoice)" 
                          *ngIf="!invoice?.canceled"
                          [disabled]="cancelable"
                        >
                          <fa-icon [icon]="icons.faTimes" class="me-2"></fa-icon>
                          Cancelar factura
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="list-group-item py-3">
                  <div class="d-flex text-center" *ngIf="loading">
                    <div class="flex-fill text-center my-5">
                      <fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon>
                    </div>
                  </div>
                  <div class="d-flex" *ngIf="!loading">
                    <div class="flex-fill">
                      <h5>Receptor</h5>
                      <table class="table table-sm my-2 border-0" style="font-size: 0.8em;">
                        <tbody>
                          <tr>
                            <th>RFC</th>
                            <td class="text-end">{{receptor.Rfc}}</td>
                          </tr>
                          <tr>
                            <th>Nombre</th>
                            <td class="text-end">{{receptor.Nombre}}</td>
                          </tr>
                          <tr>
                            <th>Regimen Fiscal</th>
                            <td class="text-end">{{receptor.RegimenFiscalReceptor}}</td>
                          </tr>
                          <tr>
                            <th>Domicilio Fiscal</th>
                            <td class="text-end">{{receptor.DomicilioFiscalReceptor}}</td>
                          </tr>
                          <tr>
                            <th>Uso CFDI</th>
                            <td class="text-end">{{receptor.UsoCFDI}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="ms-auto text-end mt-2" *ngIf="invoice?.tipo==2">
                      <button *ngIf="invoice?.tipo == 2" (click)="regenerateGlobalInvoice()" class="btn btn-sm btn-outline-secondary">
                        <fa-icon [icon]="icons.faDownload" class="me-2"></fa-icon>
                        Descargar factura
                      </button>
                      <button type="button" 
                        class="btn btn-sm btn-outline-secondary mt-2"
                        *ngIf="invoice?.canceled" 
                        (click)="downloadAcuse(invoice)"
                      >
                        <fa-icon [icon]="icons.faDownload" *ngIf="!downloading_acuse"></fa-icon>
                        <fa-icon [icon]="icons.faCircleNotch" animation="spin" *ngIf="downloading_acuse"></fa-icon>
                        Descargar acuse
                      </button>
                      <div *ngIf="authService.hasPermission('can_read_invoices')">
                        <button 
                          class="btn btn-sm btn-outline-danger mt-3" 
                          (click)="openModalDelete(invoice)" 
                          *ngIf="!invoice?.canceled"
                          [disabled]="cancelable"
                        >
                          <fa-icon [icon]="icons.faTimes" class="me-2"></fa-icon>
                          Cancelar factura
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="list-group-item py-3">
                  <h5>Información general</h5>
                  <div class="d-flex text-center" *ngIf="loading">
                    <div class="flex-fill text-center my-5">
                      <fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon>
                    </div>
                  </div>
                  <div class="d-flex" *ngIf="!loading">
                    <table class="table table-sm my-2 border-0" style="font-size: 0.8em;">
                      <tbody>
                        <tr>
                          <th>Folio fiscal</th>
                          <td class="text-end">{{invoice?.uuid}}</td>
                        </tr>
                        <tr>
                          <th>Fecha de timbrado</th>
                          <td class="text-end">{{invoice?.fecha | date: 'dd/MM/yy HH:mm'}}</td>
                        </tr>
                        <tr>
                          <th>Tipo de documento</th>
                          <td class="text-end">
                            {{invoiceType(invoice?.tipo)}}
                          </td>
                        </tr>
                        <tr>
                          <th>Serie</th>
                          <td class="text-end">{{serie}}</td>
                        </tr>
                        <tr>
                          <th>Recibo</th>
                          <td class="text-end">{{folio}}</td>
                        </tr>
                        <tr>
                          <th>Forma de pago</th>
                          <td class="text-end">{{invoice?.formaPago}}</td>
                        </tr>
                        <tr>
                          <th>Método de pago</th>
                          <td class="text-end">{{invoice?.metodoPago}}</td>
                        </tr>
                        <tr>
                          <th>Uso del CFDI</th>
                          <td class="text-end">{{invoice?.usoCFDI}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>              
                <div class="list-group-item py-3">
                  <div class="d-flex text-center" *ngIf="loading">
                    <div class="flex-fill text-center my-5">
                      <fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon>
                    </div>
                  </div>
                  <div class="" *ngIf="!loading">
                    <h5>Conceptos</h5>
                    <div class="d-flex">
                      <table class="table table-sm mt-2 border-0" style="font-size: 0.8em !important;">
                        <thead>
                          <tr>
                            <th>Cantidad</th>
                            <th>Clave</th>
                            <th scope="col" class="text-end">IVA</th>
                            <th scope="col" class="text-end">Importe</th>
                          </tr>
                        </thead>
                        <tbody *ngIf="conceptos.length>0">
                          <tr *ngFor="let concepto of conceptos">
                            <td>{{concepto['$']['Cantidad']}}</td>
                            <td>{{concepto['$']['ClaveUnidad']}}</td>
                            <td scope="col" class="text-end">{{concepto['cfdi:Impuestos'][0]['cfdi:Traslados'][0]['cfdi:Traslado'][0]['$']['Importe'] | currency}}</td>
                            <td scope="col" class="text-end">{{concepto['$']['Importe'] | currency}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="">
                      <table class="table table-sm mt-4 border-0" style="font-size: 0.8em !important;">
                        <thead>
                          <tr>
                            <td class="text-secondary">Subtotal</td>
                            <td scope="col" class="text-end text-secondary">{{impuestos['Base'] | currency}}</td>
                          </tr>
                          <tr>
                            <td class="text-secondary">IVA</td>
                            <td scope="col" class="text-end text-secondary">{{impuestos['Importe'] | currency}}</td>
                          </tr>
                          <tr class="border-bottom-0">
                            <td class="border-bottom-0">Total</td>
                            <td scope="col" class="text-end border-bottom-0">{{total | currency}}</td>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ms-2" style="min-width: 360px !important; width: 360px !important; max-width: 360px !important;" *ngIf="invoice">
              <div class="list-group mb-5" *ngIf="invoice?.tipo===2">
                <div class="list-group-item py-3">
                  <h5>Recibos</h5>
                  <table class="table table-sm" style="font-size: 0.8em;">
                    <thead>
                      <th># Recibo</th>
                      <th class="text-center">Periodo</th>
                      <th class="text-center">IVA</th>
                      <th class="text-center">Importe</th>
                    </thead>
                    <tbody>
                      <tr *ngFor="let bill of invoice?.related">
                        <td># {{bill?.id}}</td>
                        <td class="text-center">{{bill?.periodo_inicio | date: 'dd/MM/yyyy'}}</td>
                        <td class="text-center">{{bill?.taxes | currency}}</td>
                        <td class="text-center">{{bill?.total | currency}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="list-group mb-5" *ngIf="invoice?.tipo==0">
                <div class="list-group-item py-3" *ngIf="invoice.tipo!=5">
                  <h5 class="mb-3">Recibo</h5>
                  <div class="d-flex">
                    <div class="flex-fill">
                      <h4 class="mb-0"><a routerLink="/pagos/recibos/{{bill?.id}}"># {{bill?.id}}</a></h4>
                      <table class="table table-sm rounded-2 border-0 mt-2" style="font-size: 0.8em;">
                        <tbody>
                          <tr>
                            <th scope="col" colspan="1">
                              <span *ngIf="unitInfo?.settlement?.tipo == 0">Condominio</span>
                              <span *ngIf="unitInfo?.settlement?.tipo == 1">Comercial</span>
                            </th>
                            <td class="text-end" colspan="3">{{unitInfo?.settlement?.name}}</td>
                          </tr>
                          <tr>
                            <th scope="col" colspan="1">
                              <span *ngIf="unitInfo?.settlement?.tipo == 0">Departamento</span>
                              <span *ngIf="unitInfo?.settlement?.tipo == 1">Local</span>
                            </th>
                            <td class="text-end" colspan="3">{{unitInfo?.unit?.name}}</td>
                          </tr>
                          <tr class="border-bottom-secondary">
                            <th>Consumo</th>
                            <td scope="col" class="text-end" *ngIf="bill?.consumo_m3">{{bill?.consumo_m3 | number: '1.2-2'}} M<sup>3</sup></td>
                            <td scope="col" class="text-end" *ngIf="!bill?.consumo_m3">-- M<sup>3</sup></td>
                            <td scope="col" class="text-end" *ngIf="bill?.consumo_lt ">{{bill?.consumo_lt | number: '1.2-2'}} Lts.</td>
                            <td scope="col" class="text-end" *ngIf="!bill?.consumo_lt ">-- Lts.</td>
                          </tr>
                          <tr class="border-bottom-secondary">
                            <th>Lectura</th>
                            <td class="text-end" *ngIf="bill?.read_prev">Ant. {{bill?.read_prev }}</td>
                            <td class="text-end" *ngIf="!bill?.read_prev">Ant. -</td>
                            <td class="text-end" *ngIf="bill?.read_curr">Act. {{bill?.read_curr}}</td>
                            <td class="text-end" *ngIf="!bill?.read_curr">Act. -</td>
                          </tr>
                          <tr class="border-bottom-secondary">
                            <th>Periodo</th>
                            <td class="text-end" *ngIf="bill?.periodo_inicio">{{bill?.periodo_inicio | date: 'dd/MM/yy'}}</td>
                            <td class="text-end" *ngIf="bill?.periodo_fin">{{bill?.periodo_fin | date: 'dd/MM/yy' }}</td>
                          </tr>
                          <tr class="border-bottom-secondary">
                            <th colspan="2">Fecha de vencimiento</th>
                            <td colspan="2" class="text-end" *ngIf="bill?.due_date">{{bill?.due_date | date: 'dd/MM/yy' }}</td>
                          </tr>
                        </tbody>
                      </table>                    
                    </div>
                  </div>
                </div>
                <div class="list-group-item py-3">
                  <div class="d-flex">
                    <div class="flex-fill">
                      <h5 class="mb-3">Transacción / Pago</h5>
                      <div class="flex-fill text-center my-4" *ngIf="!transaction&&!invoice?.canceled">
                        <button type="button"
                          class="btn btn-sm btn-outline-secondary"
                          *ngIf="authService.hasPermission('can_read_invoices')"
                          (click)="openModalPay()"
                        >Registrar pago</button>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex" *ngIf="transaction">
                    <div class="ms-auto">
                      <div class="badge bg-light py-2 px-2 me-2 border text-center">
                        <img [src]="cardType(transaction?.payment_method_brand)" alt="Card image cap" width="44"> 
                      </div>
                    </div>
                    <div class="flex-fill ms-3">
                      <h4 class="mb-0"><i># {{transaction?.transaction_id}}</i></h4>
                      <p class="mb-0 text-sm">Importe de la transacción: <strong>{{transaction?.amount == null ? '—' : (transaction.amount | currency)}}</strong></p>
                      <p class="mb-0 text-sm" *ngIf="transaction.applied_amount != null">Aplicado al recibo en esta transacción: <strong>{{transaction.applied_amount | currency}}</strong></p>
                      <p class="mb-0 text-sm" *ngIf="transaction.balance_amount != null">Saldo a favor de esta transacción: <strong>{{transaction.balance_amount | currency}}</strong></p>
                      <p class="mb-0 text-sm" *ngIf="transaction.payment_date">Fecha de la transacción: <strong>{{transaction.payment_date | date: 'dd/MM/yyyy HH:mm'}}</strong></p>
                      <p class="mb-0 text-sm">Última fecha de pago del recibo: <strong>{{(bill?.paid_date | date: 'dd/MM/yy') || '—'}}</strong></p>
                    </div>
                  </div>
                </div>
                
                <div class="list-group-item py-3" *ngIf="invoice">
                  <div class="d-flex">
                    <div class="flex-fill">
                      <h5>Nota de crédito</h5>
                      <div class="flex-fill text-center my-4" *ngIf="!loading&&!nota&&!invoice?.canceled">
                        <button type="button"
                          class="btn btn-sm btn-outline-secondary"
                          *ngIf="authService.hasPermission('can_read_invoices')"
                          [disabled]="!bill"
                          (click)="openModalNota()"
                        >Generar nota de crédito
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="" *ngIf="nota">
                    <div class="text-sm mb-2" *ngIf="isInventoryCreditNote(nota)">
                      <div>Inventario inicial</div>
                      <div *ngIf="inventoryCreditNoteStamp(nota) !== null">
                        {{ inventoryCreditNoteStamp(nota) ? 'Timbrada' : 'No timbrada' }}
                      </div>
                      <div>Importe aplicado: <strong>{{ inventoryCreditNoteAmount(nota) === null ? '—' : (inventoryCreditNoteAmount(nota) | currency) }}</strong></div>
                    </div>
                    <div>
                      <table class="table table-sm" style="font-size: 0.8em;">
                        <tbody>
                          <tr>
                            <th>Folio fiscal</th>
                            <td class="text-end">{{nota.uuid || nota.comprobante?.['cfdi:Complemento']?.[0]?.['tfd:TimbreFiscalDigital']?.[0]?.['$']?.['UUID'] || '—'}}</td>
                          </tr>
                          <tr>
                            <th>Serie</th>
                            <td class="text-end">{{nota.serie || nota.comprobante?.['$']?.['Serie'] || '—'}}</td>
                          </tr>
                          <tr>
                            <th>Tipo</th>
                            <td class="text-end">{{nota.comprobante?.['$']?.['TipoDeComprobante'] || '—'}}</td>
                          </tr>
                          <tr>
                            <th>Fecha</th>
                            <td class="text-end">{{(nota.comprobante?.['cfdi:Complemento']?.[0]?.['tfd:TimbreFiscalDigital']?.[0]?.['$']?.['FechaTimbrado'] || nota.fecha || nota.created_at | date: 'dd/MM/yyyy HH:mm') || '—'}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="mt-2" *ngIf="nota.conceptos?.length">
                      <table class="table table-sm" style="font-size: 0.8em;">
                        <thead>
                          <tr>
                            <th>Qty.</th>
                            <th class="text-center">Clave</th>
                            <th>Descripción</th>
                            <th class="text-center">IVA</th>
                            <th>Importe</th>                        
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let concepto of nota.conceptos">
                            <td>{{concepto['$']['Cantidad']}}</td>
                            <td class="text-center">{{concepto['$']['ClaveUnidad']}}</td>
                            <td>{{concepto['$']['Descripcion']}}</td>
                            <td scope="col" class="text-cener">{{concepto['cfdi:Impuestos']?.[0]?.['cfdi:Traslados']?.[0]?.['cfdi:Traslado']?.[0]?.['$']?.['Importe'] | currency}}</td>
                            <td scope="col" class="text-end">{{concepto['$']['Importe'] | currency}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="text-end" *ngIf="nota?.comprobante">
                    <div class="text-end">
                      <button type="button" class="btn btn-sm btn-outline-secondary"
                        [disabled]="downloading_note"
                        (click)="generateNota()"
                      >
                        <fa-icon [icon]="icons.faDownload" class="me-2"></fa-icon>
                        Descargar
                      </button>
                      <button class="btn btn-sm btn-outline-danger ms-2" (click)="openModalDelete(nota)" *ngIf="nota.uuid && authService.hasPermission('can_read_invoices')">
                        <fa-icon [icon]="icons.faTimes" class="me-2"></fa-icon>
                        Cancelar
                      </button>
                    </div>
                  </div>

                  <div class="mt-4" *ngIf="notas_canceled.length>0">
                    <h5 style="font-size: 12px !important;">Notas de crédito canceladas</h5>
                    <table class="table table-sm" style="font-size: 0.8em;">
                      <tbody>
                        <tr *ngFor="let canceled of notas_canceled">
                          <td style="vertical-align: middle;">{{canceled.uuid || canceled.nota_acuse?.['Acuse']?.['Folios']?.[0]?.['UUID'] || '—'}}</td>
                          <td class="text-end">
                            <button type="button" class="btn btn-sm btn-link text-secondary py-0" (click)="downloadAcuse(canceled)" *ngIf="canceled.acuse">
                              <fa-icon [icon]="icons.faDownload" *ngIf="!downloading_acuse"></fa-icon>
                              <fa-icon [icon]="icons.faCircleNotch" animation="spin" *ngIf="downloading_acuse"></fa-icon>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="list-group-item py-3">
                  <div class="d-flex">
                    <div class="flex-fill">
                      <h5>Complemento de pago</h5>
                      <div class="flex-fill text-center my-4" *ngIf="!complemento">
                        <button type="button"
                          class="btn btn-sm btn-outline-secondary"
                          (click)="openModalComplemento()"
                          *ngIf="authService.hasPermission('can_read_invoices')&&!invoice.canceled"
                          [disabled]="!transaction && !bill?.status"
                        >Generar complemento
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex" *ngIf="complemento">
                    <div class="flex-fill">
                      <table class="table table-sm" style="font-size: 0.8em;">
                        <tbody>
                          <tr>
                            <th>Folio fiscal</th>
                            <td class="text-end">{{complemento?.uuid}}</td>
                          </tr>
                          <tr>
                            <th>Fecha pago</th>
                            <td class="text-end">{{complemento?.comprobante?.['pago20:Pago']?.[0]?.['$']?.['FechaPago'] | date: 'dd/MM/yyyy'}}</td>
                          </tr>
                          <tr>
                            <th>Moneda</th>
                            <td class="text-end">{{complemento?.documento?.['MonedaDR']}}</td>
                          </tr>
                          <tr>
                            <th>Parcialidad</th>
                            <td class="text-end">{{complemento?.documento?.['NumParcialidad']}}</td>
                          </tr>
                          <tr>
                            <th>Saldo</th>
                            <td class="text-end">{{complemento?.documento?.['ImpSaldoAnt'] | currency}}</td>
                          </tr>
                          <tr>
                            <th>Pago</th>
                            <td class="text-end">{{complemento?.documento?.['ImpPagado'] | currency}}</td>
                          </tr>
                          <tr>
                            <th>Insoluto</th>
                            <td class="text-end">{{complemento?.documento?.['ImpSaldoInsoluto'] | currency}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="d-flex" *ngIf="complemento">
                    <div class="flex-fill text-end">
                      <button type="button" (click)="regenerateComplement(complemento)" class="btn btn-sm btn-outline-secondary">
                        <fa-icon [icon]="icons.faDownload" class="me-2"></fa-icon>
                        Descargar
                      </button>
                      <button type="button" 
                        class="btn btn-sm btn-outline-danger ms-2" 
                        (click)="openModalDelete(complemento)" 
                        *ngIf="authService.hasPermission('can_read_invoices')"
                      >
                        <fa-icon [icon]="icons.faTimes" class="me-2"></fa-icon>
                        Cancelar
                      </button>
                    </div>
                  </div>

                  <div class="mt-4" *ngIf="complementos_canceled.length>0">
                    <h5 style="font-size: 12px !important;">Complementos de cancelados</h5>
                    <table class="table table-sm" style="font-size: 0.8em;">
                      <tbody>
                        <tr *ngFor="let canceled of complementos_canceled">
                          <td style="vertical-align: middle;">{{canceled.uuid || canceled.complemento_acuse?.['Acuse']?.['Folios']?.[0]?.['UUID'] || '—'}}</td>
                          <td class="text-end">
                            <button type="button" class="btn btn-sm btn-link text-secondary py-0" (click)="downloadAcuse(canceled)" *ngIf="canceled.acuse">
                              <fa-icon [icon]="icons.faDownload" *ngIf="!downloading_acuse"></fa-icon>
                              <fa-icon [icon]="icons.faCircleNotch" animation="spin" *ngIf="downloading_acuse"></fa-icon>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-modal-invoice-complement 
      [profile]="profile"
      [invoice]="invoice" 
      [bill]="bill"
      [conceptos]="conceptos" 
      [receptor]="receptor"
      [transaction]="transaction"
      (updateDismiss)="updateDismissed()"
    ></app-modal-invoice-complement>
    <app-modal-invoice-nota 
      [profile]="profile"
      [invoice]="invoice"
      [bill]="bill" 
      [conceptos]="conceptos" 
      [base]="base" 
      [total]="total"
      (updateDismiss)="updateDismissed()"
    ></app-modal-invoice-nota>
    <app-modal-invoice-cancel 
      [profile]="profile"
      [invoice]="cancel_invoice"
      (updateDismiss)="updateDismissed()"
    ></app-modal-invoice-cancel>
    <app-modal-options-pay 
      [bill]="bill"
      [profile]="profile"
      (billData)="paymentRegistered($event)"
      (updateDismiss)="updateDismissed()"
    ></app-modal-options-pay>
  `,
  styleUrls: []
})
export class InvoiceShowComponent implements AfterViewInit {
  parser: any;
  profile: any = {};
  permissions: any = {};
  receiptUrl: string = 'https://receipt.zazz.mx'; // environment.RECIBOS_REST_WSPREFIX;
  invoice: any = null;
  bill: any = null;  
  transaction: any = null;
  unitInfo: any = null;

  currentView: string = 'invoices';

  emisor: any = {};
  receptor: any = {};
  conceptos: any[] = [];
  impuestos: any = {};
  serie: any = null;
  folio: any = null;
  base: number = 0;
  total: number = 0;

  complemento: any = null;
  nota: any = null;
  readonly isInventoryCreditNote = isInventoryCreditNote;
  readonly inventoryCreditNoteAmount = inventoryCreditNoteAmount;
  readonly inventoryCreditNoteStamp = inventoryCreditNoteStamp;
  complementos_canceled: any[] = [];
  notas_canceled: any[] = [];
  cancel_invoice: any = null;
  loading: boolean = true;
  downloading_acuse: boolean = false;
  downloading_invoice: boolean = false;
  downloading_note: boolean = false;
  cancelable: boolean = false;

  @ViewChild(ModalInvoiceComplementComponent, { static: true }) modalInvoiceComplement !: ModalInvoiceComplementComponent;
  @ViewChild(ModalInvoiceNotaComponent, { static: true }) modalInvoiceNota !: ModalInvoiceNotaComponent;
  @ViewChild(ModalInvoiceCancelComponent, { static: true }) modalInvoiceCancel !: ModalInvoiceCancelComponent;
  @ViewChild(ModalOptionsPayComponent, { static: true }) modalOptionsPay !: ModalOptionsPayComponent;
  storageService = inject(StorageService);
  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    private activateRoute: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    public icons: IconsService,
    public images: ImageService,
    public authService: AuthService,
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
        this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    this.activateRoute.params.subscribe(params => {
      this.loadInvoice(params['id']);
    });
  }

  ngAfterViewInit(): void {
    // this.loadLogo();
  }

  async loadLogo() {
    const img = this.images.buildURL(this.profile.logo);
    const imx: any = await this.images.getBase64ImageFromUrl(img);
    this.profile.logo = `data:image/jpeg;base64,${imx.split(',')[1]}`;
  }

  async loadInvoice(id: any) {
    this.loading = true;
    this.transaction = null;
    this.bill = null;
    this.complemento = null;
    this.nota = null;
    this.cancelable = false;
    this.complementos_canceled = [];
    this.notas_canceled = [];
    this.unitInfo = null;
    this.emisor = {};
    this.receptor = {};
    this.conceptos = [];
    this.impuestos = {};
    this.base = 0;
    this.total = 0;
    this.store.getInvoice(id).subscribe({
      next: async (res: any) => {
        this.invoice = res.invoice;

        const comprobante: any = await this.processXML(this.invoice.cfdixml);
        if (comprobante?.['cfdi:Comprobante']) {
          this.serie = comprobante['cfdi:Comprobante']['$']['Serie'];
          this.folio = comprobante['cfdi:Comprobante']['$']['Folio'];
          this.receptor = comprobante['cfdi:Comprobante']['cfdi:Receptor'][0]['$'];
          this.emisor = comprobante['cfdi:Comprobante']['cfdi:Emisor'][0]['$'];
          this.conceptos = comprobante['cfdi:Comprobante']['cfdi:Conceptos'][0]['cfdi:Concepto'];
          this.impuestos = comprobante['cfdi:Comprobante']['cfdi:Impuestos']?.[0]?.['cfdi:Traslados']?.[0]?.['cfdi:Traslado']?.[0]?.['$'] ?? {};
          this.base = Number(comprobante['cfdi:Comprobante']['$']['SubTotal']);
          this.total = Number(comprobante['cfdi:Comprobante']['$']['Total']);
        }

        if (this.invoice.tipo == 5) {
          this.breadcrumbService.set('@invoiceShow', this.invoice.id);
          this.loading = false;
          return;
        } else if (this.invoice.tipo == 0) {
          this.store.getBill(this.invoice.folio).subscribe((bill: any) => {
            this.bill = bill;

            this.store.getUnitSettlement(bill.unit_id).subscribe((unit: any) => {
              this.unitInfo = unit;
            });

            this.store.getTransactionByBill(bill.id).subscribe((transaction: any) => {
              this.transaction = transaction;
            });
          });
        } else if (this.invoice.tipo === 2) {
          this.store.getBillsQuery({ invoice_id: this.invoice.id }).subscribe((bills: any) => {
            this.invoice.related = bills.data;
          });
        }

        this.complementos_canceled = [];
        this.notas_canceled = [];
        if (Array.isArray(res.related) && res.related.length > 0) {
          await this.processRelated(res.related);
        }

        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.toastr.error(err?.error?.message || 'No fue posible consultar la factura.', 'Error');
      }
    });
  }

  cardType(card: any) {
    if (card == 'VI') {
      return "/assets/images/icon-visa-sm.png";
    } else if (card == 'MC') {
      return "/assets/images/icon-mastercard-sm.png";
    } else if (card == 'AMEX') {
      return "/assets/images/icon-amex-sm.png";
    } else if (card == 'CASH') {
      return "/assets/images/icon-cash.png";
    } else {
      return "/assets/images/icon-visa-sm.png";
    }
  }

  invoiceType(type: number) {
    if (type == 0) {
      return 'Factura Ingreso';
    } else if (type == 3) {
      return 'Nota de crédito';
    } else if (type == 2) {
      return 'Factura Global';
    } else if (type == 1) {
      return '';
    } else if (type == 4) {
      return 'Cancelada';
    } else if (type == 5) {
      return 'Factura ingreso genérica';
    } else if (type == 6) {
      return 'Complemento de pago';
    } else {
      return 'Factura';
    }
  }

  async processXML(xml: any) {
    if (typeof xml !== 'string' || !xml.trim()) return null;
    const parser = new xml2js.Parser({
      trim: true,            
      explicitArray: true,            
    });
    try {
      return await parser.parseStringPromise(xml);
    } catch {
      return null;
    }
  }

  async processRelated(related: any) {

    let canceled: any[] = [];
    canceled = related.filter((item: any) => item.canceled == true);
    this.cancelable = related.length === canceled.length ? false : true;

    let complmentos: any[] = [];
    complmentos = related.filter((item: any) => item.tipo == 6);
    this.complemento = complmentos.find((item: any) => item.canceled == false);
    if (this.complemento) {
      const complemento_comprobante: any = await this.processXML(this.complemento.cfdixml);
      this.complemento.comprobante = complemento_comprobante?.['cfdi:Comprobante']?.['cfdi:Complemento']?.[0]?.['pago20:Pagos']?.[0];
      this.complemento.documento = this.complemento.comprobante?.['pago20:Pago']?.[0]?.['pago20:DoctoRelacionado']?.[0]?.['$'];
    }

    let complementosCanceled: any[] = [];
    complementosCanceled = related.filter((item: any) => item.tipo == 6 && item.canceled == true);
    this.complementos_canceled = await Promise.all(complementosCanceled.map(async (complemento: any) => ({
      ...complemento,
      complemento_acuse: await this.processXML(complemento.acuse),
    })));

    let notas: any[] = [];
    notas = related.filter((item: any) => item.tipo == 3);
    const note = notas.find((item: any) => item.canceled == false);
    this.nota = null;
    if (note) {
      const parsed = await this.processXML(note.cfdixml);
      const comprobante = parsed?.['cfdi:Comprobante'] ?? null;
      this.nota = { ...note, comprobante, conceptos: comprobante?.['cfdi:Conceptos']?.[0]?.['cfdi:Concepto'] ?? [] };
      if (hasCreditNoteXml(note) && !comprobante) this.toastr.error('No fue posible leer el XML de la nota de crédito.');
    }

    let notasCanceled: any[] = [];
    notasCanceled = related.filter((item: any) => item.tipo == 3 && item.canceled == true);
    this.notas_canceled = await Promise.all(notasCanceled.map(async (nota: any) => ({
      ...nota,
      nota_acuse: await this.processXML(nota.acuse),
    })));

  }

  downloadXML(invoice: any, filename = `${invoice.serie}_${invoice.folio}.xml`) {
    const blob2 = new Blob([invoice.cfdixml], { type: 'application/xml' });

    var fileURL2 = window.URL.createObjectURL(blob2);
    var link2=document.createElement('a');

    link2.href = fileURL2;
    link2.download = filename;
    link2.click();
  }

  openModalComplemento() {
    const modalTemplate: any | undefined = this.modalInvoiceComplement;
    if (modalTemplate) {
      this.modalInvoiceComplement.openModal(modalTemplate['modalInvoiceComplement']);
    }
  }

  openModalNota() {
    const modalTemplate: any | undefined = this.modalInvoiceNota;
    if (modalTemplate) {
      this.modalInvoiceNota.openModal(modalTemplate['modalInvoiceNota']);
    }
  }

  openModalDelete(factura: any) {
    this.cancel_invoice = factura;
    const modalTemplate: any | undefined = this.modalInvoiceCancel;
    if (modalTemplate) {
      this.modalInvoiceCancel.openModal(modalTemplate['modalInvoiceCancel']);
    }
  }

  openModalPay() {
    const modalTemplate: any | undefined = this.modalOptionsPay;
    if (modalTemplate) {
      this.modalOptionsPay.openModal(modalTemplate['modalOptionsPay']);
    }
  }

  regenerateComplement(complemento: any) {
    this.store.downloadComplement({
      invoiceData: complemento,
      unitData: this.unitInfo.unit,
      buildingData: this.unitInfo.building,
      utilityData: this.profile
    }).subscribe({
      next: (data: any) => {
        this.loading = false;

        const int8Array = new Uint8Array(data.result.data);
        const blob = new Blob([int8Array], { type: 'application/pdf' });

        var fileURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');

        link.href = fileURL;
        link.download = `COMPLEMENTO_${complemento.id}.pdf`;
        link.click();

        this.downloadXML(complemento, `COMPLEMENTO_${complemento.id}.xml`);

        this.toastr.success('Factura descargada correctamente.', 'Éxito');
      },
      error: (err: any) => {
        if (err.status >= 500) {
          this.toastr.error('Ocurrió un error al descargar la factura.', 'Error');
        }
        this.loading = false;
      }
    });
  }

  regenerateInvoice() {
    
    let dueDate = new Date(this.bill.due_date);
    dueDate.setDate(dueDate.getDate());
    dueDate.toISOString().substring(0, 10);

    this.store.getUnitSettlement(this.bill.unit_id).subscribe(async (response: any) => {
      this.store.getProfile(this.profile.id).subscribe(async (profile: any) => {              
        let utilityData = profile;

        await this.store.getPreviousBill(this.bill.id).subscribe(async (prevBill: any) => {
          
          this.store.downloadInvoice({
            bill: this.bill,
            dueDate: dueDate,
            unitData: response.unit,
            settlementData: response.settlement,
            buildingData: response.building,
            utilityData: utilityData,
            invoiceData: this.invoice,
            prev_bill: prevBill
          }).subscribe({
            next: (data: any) => {
              this.store.saveInvoicePdf(this.invoice.id, { pdf: data.filename });

              this.loading = false;

              const int8Array = new Uint8Array(data.result.data);
              const blob = new Blob([int8Array], { type: 'application/pdf' });

              var fileURL = window.URL.createObjectURL(blob);
              var link=document.createElement('a');

              link.href = fileURL;
              link.download = data.filename;
              link.click();

              const blob2 = new Blob([this.invoice.cfdixml], { type: 'application/xml' });

              var fileURL2 = window.URL.createObjectURL(blob2);
              var link2=document.createElement('a');

              link2.href = fileURL2;
              link2.download = `${this.invoice.serie}_${this.invoice.folio}.xml`;
              link2.click();
              
              return;
            }, error: (error: any) => {
              this.toastr.error('Ocurrió un error al descargar la factura', 'Error');
              console.error(error);
              this.loading = false;
            }
          });
        });
      });
    });
  }

  regenerateGlobalInvoice() {
    this.store.downloadGlobal({
      invoiceData: this.invoice,
      utilityData: this.profile
    }).subscribe({
      next: (data: any) => {
        this.loading = false;

        const int8Array = new Uint8Array(data.result.data);
        const blob = new Blob([int8Array], { type: 'application/pdf' });

        var fileURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');

        link.href = fileURL;
        link.download = data.filename;
        link.click();

        const blob2 = new Blob([this.invoice.cfdixml], { type: 'application/xml' });

        var fileURL2 = window.URL.createObjectURL(blob2);
        var link2=document.createElement('a');

        link2.href = fileURL2;
        link2.download = `${this.serie}_${this.folio}.xml`;
        link2.click();

        this.toastr.success('Factura descargada correctamente.', 'Éxito');
      }
    });
  }

  regenerateGenericInvoice() {
    this.store.downloadGenericInvoice({
      invoiceData: this.invoice,
      utilityData: this.profile
    }).subscribe({
      next: (data: any) => {
        this.loading = false;

        const int8Array = new Uint8Array(data.result.data);
        const blob = new Blob([int8Array], { type: 'application/pdf' });

        var fileURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');

        link.href = fileURL;
        link.download = data.filename;
        link.click();

        const blob2 = new Blob([this.invoice.cfdixml], { type: 'application/xml' });

        var fileURL2 = window.URL.createObjectURL(blob2);
        var link2=document.createElement('a');

        link2.href = fileURL2;
        link2.download = `${this.serie}_${this.folio}.xml`;
        link2.click();

        this.toastr.success('Factura descargada correctamente.', 'Éxito');
      },
      error: (err: any) => {
        console.error(err);
        if (err.status >= 500) {
          this.toastr.error('Ocurrió un error al descargar la factura.', 'Error');
        }
        this.loading = false;
      }
    });
  }

  generateNota() {
    if (this.downloading_note || !this.nota?.comprobante) return;
    this.downloading_note = true;
    this.store.downloadNota({
      invoiceData: this.nota,
      utilityData: this.profile,
      conceptos: []
    }).subscribe({
      next: (data: any) => {
        this.downloading_note = false;

        const int8Array = new Uint8Array(data.result.data);
        const blob = new Blob([int8Array], { type: 'application/pdf' });

        var fileURL = window.URL.createObjectURL(blob);
        var link=document.createElement('a');

        link.href = fileURL;
        link.download = data.filename;
        link.click();

        const blob2 = new Blob([this.nota.cfdixml], { type: 'application/xml' });

        var fileURL2 = window.URL.createObjectURL(blob2);
        var link2=document.createElement('a');

        link2.href = fileURL2;
        link2.download = `${this.nota.serie}_${this.nota.folio}.xml`;
        link2.click();

        window.URL.revokeObjectURL(fileURL);
        window.URL.revokeObjectURL(fileURL2);
        this.toastr.success('Nota de crédito descargada correctamente.', 'Éxito');
      },
      error: () => {
        this.downloading_note = false;
        this.toastr.error('No fue posible descargar la nota de crédito. Intenta nuevamente.', 'Error');
      }
    });
  }

  downloadAcuse(invoice: any) {
    this.downloading_acuse = true;
    const payload: any = {
      utilityData: this.profile,
      invoiceData: invoice,
    };

    this.store.createAcuseCancel(payload).subscribe({
      next: (data: any) => {
        const int8Array = new Uint8Array(data.result.data);
        const blob = new Blob([int8Array], { type: 'application/pdf' });

        var fileURL = window.URL.createObjectURL(blob);
        var link=document.createElement('a');

        link.href = fileURL;
        link.download = data.filename;
        link.click();

        const blob2 = new Blob([payload.invoiceData.acuse], { type: 'application/xml' });

        var fileURL2 = window.URL.createObjectURL(blob2);
        var link2=document.createElement('a');

        link2.href = fileURL2;
        link2.download = `ACUSE_${payload.invoiceData.serie}_${payload.invoiceData.folio}.xml`;
        link2.click();

        this.downloading_acuse = false;
      },
      error: (err: any) => {
        console.error(err);
        this.downloading_acuse = false;
        this.toastr.error('Ocurrió un error al generar el acuse de cancelación.', 'Error');
      }
    });
  }

  updateDismissed() {
    this.loadInvoice(this.activateRoute.snapshot.params['id']);
  }

  paymentRegistered(event: any) {
    this.bill = event?.bill ?? this.bill;
    const transactionData = event?.transaction?.data;
    this.transaction = transactionData?.attributes
      ? { id: transactionData.id, ...transactionData.attributes }
      : event?.transaction;

    if (this.bill) {
      this.bill = {
        ...this.bill,
        status: this.bill.status ?? true,
        paid_date: this.bill.paid_date ?? this.transaction?.payment_date,
      };
    }
  }
}
